// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout_container__3LmzN","copyright":"Layout_copyright__19hdp","footer":"Layout_footer__VmFFy"};